import { useState } from "react";
import { Smile } from "lucide-react";
import { Transition } from "@headlessui/react";
import { EMOJI_CATEGORIES, panelClasses } from "../utils/constants";

const EmojiPicker = ({ isOpen, setIsOpen, onSelect, closeOthers }) => {
  const [activeCategory, setActiveCategory] = useState("Smileys");

  return (
    <div>
      <button
        onClick={() => {
          closeOthers?.();
          setIsOpen(!isOpen);
        }}
        className="inline-flex items-center gap-1.5 py-1 text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200 transition-colors"
      >
        <Smile className="h-3.5 w-3.5" strokeWidth={2} />
        <span className="text-[13px]">Emoji</span>
      </button>

      <Transition
        show={isOpen}
        enter="transition duration-150 ease-out"
        enterFrom="opacity-0 translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition duration-100 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div className="absolute left-0 right-0 bottom-full z-[70]">
          <div className={panelClasses}>
            <div className="p-2">
              <div className="flex gap-1 mb-2">
                {Object.keys(EMOJI_CATEGORIES).map((cat) => (
                  <button
                    key={cat}
                    onClick={() => setActiveCategory(cat)}
                    className={[
                      "px-2.5 py-1 text-[12px] rounded-md transition-colors",
                      activeCategory === cat
                        ? "bg-zinc-200 dark:bg-zinc-700 text-zinc-900 dark:text-zinc-100"
                        : "text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200",
                    ].join(" ")}
                  >
                    {cat}
                  </button>
                ))}
              </div>
              <div className="grid grid-cols-9 gap-0.5 max-h-[160px] overflow-y-auto">
                {EMOJI_CATEGORIES[activeCategory].map((emoji) => (
                  <button
                    key={emoji}
                    onClick={() => {
                      onSelect(emoji);
                      setIsOpen(false);
                    }}
                    className="h-8 w-8 flex items-center justify-center text-[18px] rounded hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors"
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default EmojiPicker;
